import { render, staticRenderFns } from "./DepotUserModal.vue?vue&type=template&id=16c30aa8&scoped=true"
import script from "./DepotUserModal.vue?vue&type=script&lang=js"
export * from "./DepotUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c30aa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c30aa8')) {
      api.createRecord('16c30aa8', component.options)
    } else {
      api.reload('16c30aa8', component.options)
    }
    module.hot.accept("./DepotUserModal.vue?vue&type=template&id=16c30aa8&scoped=true", function () {
      api.rerender('16c30aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepotUserModal.vue"
export default component.exports